import ScopedCssBaseline from '@material-ui/core/ScopedCssBaseline'

export default ScopedCssBaseline
